module.exports = __webpack_public_path__ + "static/media/offer-page-phone_graphic.00b30e39.png";